import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=66fe5c2f&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fe5c2f')) {
      api.createRecord('66fe5c2f', component.options)
    } else {
      api.reload('66fe5c2f', component.options)
    }
    module.hot.accept("./roles.vue?vue&type=template&id=66fe5c2f&", function () {
      api.rerender('66fe5c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolemanagement/roles/roles.vue"
export default component.exports